import { Stack, TextInput } from "@mantine/core"
import { Form } from "../../../-components/typed-form"
import { CreateUserAuthenticationFactor } from "../../../@client/Theasoft_ApiServer_UserAuthenticationFactors"
import { FormButtonGroup } from "../../../-components/form-button-group"
import { CancelButton, SubmitButton } from "../../../-components/Buttons"
import { SelectAuthenticationFactorType } from "./select-authentication-factor-type"
import { AuthenticationFactorType_AllValues } from "../../../@client/Theasoft_DataTypes_Enums"
import { useSendCodeMutation } from "./use-send-code-mutation"
import { useTranslation } from "react-i18next"
import { useGetAllowedAuthenticationFactors } from "./use-get-allowed-authentication-factors"

interface Props {
  onCancel: () => void
  onSuccess: (id: number) => void
}

export function CreateUserAuthenticationFactorForm({
  onCancel,
  onSuccess,
}: Props) {
  const { mutate: sendTotpCode } = useSendCodeMutation()
  const { i18n, t } = useTranslation("app_server")
  const { t: tDataTypes } = useTranslation("DataTypes")
  const { data: allowedAuthenticationFactorTypes } =
    useGetAllowedAuthenticationFactors()

  return (
    <Form
      url="/api/UserAuthenticationFactor/CreateUserAuthenticationFactor"
      initialValues={
        {
          name: "App",
          authenticationFactorType: allowedAuthenticationFactorTypes[0],
          contactValue: "",
        } as CreateUserAuthenticationFactor
      }
      transform={(id) => id}
      options={{
        onSuccess: (id, vars) => {
          vars.authenticationFactorType ===
            AuthenticationFactorType_AllValues[1] &&
            sendTotpCode({
              userAuthenticationFactorId: id,
              language: i18n.language,
            })
          onSuccess(id)
        },
      }}
    >
      {(form, _) => (
        <Stack>
          <SelectAuthenticationFactorType
            value={form.values.authenticationFactorType}
            onChange={(value) =>
              form.setFieldValue(_.authenticationFactorType._PATH_, value)
            }
          />
          {form.values.authenticationFactorType ===
          AuthenticationFactorType_AllValues[0] ? (
            <TextInput
              required
              label={t("Name")}
              {...form.getInputProps(_.name._PATH_)}
            />
          ) : null}
          {form.values.authenticationFactorType ===
          AuthenticationFactorType_AllValues[1] ? (
            <TextInput
              required
              label={tDataTypes("KomTyp_kMail")}
              {...form.getInputProps(_.contactValue._PATH_)}
            />
          ) : null}
          <FormButtonGroup>
            <CancelButton onClick={onCancel} />
            <SubmitButton>{t("Next")}</SubmitButton>
          </FormButtonGroup>
        </Stack>
      )}
    </Form>
  )
}
